import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class SecurityDeskAbility extends Ability {
  @service declare authz: AuthzService;

  get canVisit(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_SECURITY_DESK_READ);
  }

  get canConfigure(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_LOCATION_CONFIG_UPDATE_SECURITY_DESK_LINK);
  }
}
